import { DateAsString } from '../../bostadsvardering/types/dtos/VarderingarModel';

export const formatSwedishDateTime = (timestamp: Date | DateAsString): string =>
  new Date(timestamp).toLocaleString('sv-SE');
